export default __webpack_public_path__ + "static/media/1.475e9cf1.jpg";